import React from 'react'
import { useResizeObserver } from './ResizeObserver'

export const useMediaLessThan = (
  ref: React.RefObject<HTMLElement>,
  breakpointValue: number
) => {
  const defaultValue = window.innerWidth < breakpointValue
  const [isMediaLessThan, setIsMediaLessThan] = React.useState(defaultValue)

  const handleResize = React.useCallback(
    (entries: ResizeObserverEntry[]) => {
      const element = entries[0]
      setIsMediaLessThan(element?.target.clientWidth < breakpointValue)
    },
    [breakpointValue]
  )

  const setResize = useResizeObserver(handleResize)

  React.useEffect(() => {
    setResize(ref.current)
  }, [setResize, ref])

  return isMediaLessThan
}
